import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import API from './api';
import { UserContext } from './App';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid or missing verification token.');
      return;
    }

    const verify = async () => {
      try {
        const response = await API.post('/auth/verify-email', { token });
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
        
        // If user is currently logged in, update their verification status
        if (user) {
          const updatedUser = { ...user, emailVerified: true };
          setUser(updatedUser);
          localStorage.setItem('user', JSON.stringify(updatedUser));
        }

        setTimeout(() => {
          navigate('/dashboard');
        }, 3000);
      } catch (error) {
        console.error('Verification error:', error);
        setStatus('error');
        setMessage(error.response?.data?.error || 'Failed to verify email. The link may have expired.');
      }
    };

    verify();
  }, [token, navigate, user, setUser]);

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0e0e1a, #1a1a2e)',
      padding: '20px'
    }}>
      <div style={{
        background: '#12121e',
        padding: '40px',
        borderRadius: '12px',
        border: '1px solid #1c1c32',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        <h2 style={{ color: '#ffffff', marginBottom: '20px', fontSize: '28px' }}>Email Verification</h2>
        
        {status === 'verifying' && (
          <div style={{ color: '#8a8aa5', margin: '20px 0' }}>
            <div className="spinner" style={{ margin: '0 auto 20px auto', width: '40px', height: '40px', border: '3px solid rgba(255,255,255,0.1)', borderTopColor: '#4a6cff', borderRadius: '50%', animation: 'spin 1s ease-in-out infinite' }}></div>
            {message}
          </div>
        )}

        {status === 'success' && (
          <div style={{ color: '#4cd964', margin: '20px 0', padding: '15px', background: 'rgba(76, 217, 100, 0.1)', borderRadius: '8px' }}>
            ✅ {message}
          </div>
        )}

        {status === 'error' && (
          <div style={{ color: '#ff3b30', margin: '20px 0', padding: '15px', background: 'rgba(255, 59, 48, 0.1)', borderRadius: '8px' }}>
            ❌ {message}
          </div>
        )}
        
        <div style={{ marginTop: '30px' }}>
          <Link 
            to="/dashboard"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #4a6cff, #6b85ff)',
              color: '#ffffff',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              transition: 'all 0.3s'
            }}
          >
            Return to Dashboard
          </Link>
        </div>
        
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
}

export default VerifyEmail;
